import { render, staticRenderFns } from "./IpasasAuth.vue?vue&type=template&id=e37c8792&"
import script from "./IpasasAuth.vue?vue&type=script&lang=js&"
export * from "./IpasasAuth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports